import { IconSearch, IconChartBar, IconTools, IconChartLine } from "@tabler/icons-react";

export type AnalysisTab = 'search' | 'dimensionality' | 'tools' | 'analytics';

interface AnalysisTopBarProps {
    activeTab: AnalysisTab;
    onTabChange: (tab: AnalysisTab) => void;
}

const AnalysisTopBar = ({ activeTab, onTabChange }: AnalysisTopBarProps) => {
    const tabs: { id: AnalysisTab; label: string; icon: React.ReactNode }[] = [
        { id: 'search', label: 'Search', icon: <IconSearch size={16} /> },
        { id: 'dimensionality', label: 'Dimensionality', icon: <IconChartBar size={16} /> },
        { id: 'analytics', label: 'Analytics', icon: <IconChartLine size={16} /> },
        { id: 'tools', label: 'Tools', icon: <IconTools size={16} /> }
    ];

    return (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-40">
            <div className="flex items-center gap-1 bg-gray-800/95 backdrop-blur-md rounded-full px-1 py-1 border border-gray-700 shadow-xl">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`
                            flex items-center gap-1.5 px-4 py-1.5 text-xs font-medium transition-all duration-200 rounded-full
                            ${activeTab === tab.id
                                ? 'bg-blue-600 text-white shadow-md'
                                : 'text-gray-400 hover:text-gray-200 hover:bg-gray-700/50'
                            }
                        `}
                    >
                        {tab.icon}
                        <span>{tab.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AnalysisTopBar;
